"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sync = void 0;
const typings = __importStar(require("@monorepo/typings/sdk"));
class Sync {
    sdk;
    api;
    session;
    mount;
    constructor(sdk) {
        this.sdk = sdk;
        this.api = sdk.api;
        this.session = sdk.session;
        this.mount = sdk.mount;
    }
    signIn = (hex) => this.api.request({
        command: typings.COMMANDS.SIGN,
        data: {
            tx: { TransactionType: 'SignIn' },
            hex,
        },
    });
    sign = (tx, opts) => this.api.request({
        command: typings.COMMANDS.SIGN,
        data: {
            tx,
            opts,
        },
    });
    submit = (address, txblob, opts) => this.api.request({
        command: typings.COMMANDS.SUBMIT,
        data: {
            address,
            txblob,
            opts,
        },
    });
    signAndSubmit = (tx, opts) => this.api.request({
        command: typings.COMMANDS.SIGNANDSUBMIT,
        data: {
            tx,
            opts,
        },
    });
    bulkSign = (txns, opts) => this.api.request({
        command: typings.COMMANDS.BULKSIGN,
        data: {
            txns,
            opts,
        },
    });
    bulkSubmit = (address, txblobs, opts) => this.api.request({
        command: typings.COMMANDS.BULKSUBMIT,
        data: {
            address,
            txblobs,
            opts,
        },
    });
    encrypt = {
        aes: (address, data, opts) => this.api.request({
            command: typings.COMMANDS.ENCRYPT,
            data: {
                address,
                data,
                opts,
            },
        }),
    };
    decrypt = {
        aes: (address, hex, opts) => this.api.request({
            command: typings.COMMANDS.DECRYPT,
            data: {
                address,
                hex,
                opts,
            },
        }),
    };
    bulkSignAndSubmit = (txns, opts) => this.api.request({
        command: typings.COMMANDS.BULK,
        data: {
            txns,
            opts,
        },
    });
    getResponse = (id) => this.session.responses.get(id);
    isConnected = () => this.mount.isDetected;
    isInstalled = () => this.mount.isDetected;
    isLocked = () => this.api.request({
        command: typings.COMMANDS.IS_LOCKED,
    });
    isOpen = () => this.session.isOpen;
    version = () => this.api.request({
        command: typings.COMMANDS.VERSION,
    });
    verify = (hex) => this.api.request({
        command: typings.COMMANDS.VERIFY,
        data: {
            hex,
        },
    });
    getAddress = () => this.session.address;
    getNetwork = () => this.session.network;
    getUser = () => this.session.user;
}
exports.Sync = Sync;
